document.addEventListener('DOMContentLoaded', function() {

const productZoomLinks = document.querySelectorAll('.rt-fastor-product-gallery__image .photoswipe.zoom'); 


  productZoomLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      if (this.target === '_blank') {
        event.preventDefault(); // Stop Photoswipe or EasyZoom from taking over
        window.open(this.href, '_blank'); // Manually open in new tab
      }
    });
  });
});